(function(){
"use strict";
/** Generated by generate-font-coverage.py from the bundled font files.
 * Unicode ranges include only cmap entries mapping to an actual glyph.
 * Check NFC-normalized display text; retain original customer spelling.
 */
const FONT_COVERAGE = Object.freeze({
  roman: Object.freeze({
    label: "Classic",
    family: "Cinzel",
    weight: 500,
    asset: "lettering-0.ttf",
    sha256: "bd933cb739b5125a1fda907d61ea237beadb4ac382ac7a5f9af0a8bbedaf48b7",
    codepointCount: 367,
    ranges: Object.freeze([
      Object.freeze([0x20, 0x7E]),
      Object.freeze([0xA0, 0x107]),
      Object.freeze([0x10A, 0x113]),
      Object.freeze([0x116, 0x11B]),
      Object.freeze([0x11E, 0x123]),
      Object.freeze([0x126, 0x127]),
      Object.freeze([0x12A, 0x12B]),
      Object.freeze([0x12E, 0x133]),
      Object.freeze([0x136, 0x137]),
      Object.freeze([0x139, 0x148]),
      Object.freeze([0x14A, 0x14D]),
      Object.freeze([0x150, 0x15B]),
      Object.freeze([0x15E, 0x167]),
      Object.freeze([0x16A, 0x16B]),
      Object.freeze([0x16E, 0x17E]),
      Object.freeze([0x192, 0x192]),
      Object.freeze([0x218, 0x21B]),
      Object.freeze([0x2C6, 0x2C7]),
      Object.freeze([0x2D8, 0x2DD]),
      Object.freeze([0x300, 0x304]),
      Object.freeze([0x306, 0x308]),
      Object.freeze([0x30A, 0x30C]),
      Object.freeze([0x326, 0x328]),
      Object.freeze([0x394, 0x394]),
      Object.freeze([0x3A9, 0x3A9]),
      Object.freeze([0x3BC, 0x3BC]),
      Object.freeze([0x3C0, 0x3C0]),
      Object.freeze([0x1E80, 0x1E85]),
      Object.freeze([0x1EF2, 0x1EF3]),
      Object.freeze([0x2013, 0x2014]),
      Object.freeze([0x2018, 0x201A]),
      Object.freeze([0x201C, 0x201E]),
      Object.freeze([0x2020, 0x2022]),
      Object.freeze([0x2026, 0x2026]),
      Object.freeze([0x2030, 0x2030]),
      Object.freeze([0x2039, 0x203A]),
      Object.freeze([0x2044, 0x2044]),
      Object.freeze([0x2074, 0x2074]),
      Object.freeze([0x20AC, 0x20AC]),
      Object.freeze([0x2122, 0x2122]),
      Object.freeze([0x2202, 0x2202]),
      Object.freeze([0x220F, 0x220F]),
      Object.freeze([0x2211, 0x2212]),
      Object.freeze([0x2215, 0x2215]),
      Object.freeze([0x221A, 0x221A]),
      Object.freeze([0x221E, 0x221E]),
      Object.freeze([0x222B, 0x222B]),
      Object.freeze([0x2248, 0x2248]),
      Object.freeze([0x2260, 0x2260]),
      Object.freeze([0x2264, 0x2265]),
      Object.freeze([0x25CA, 0x25CA]),
      Object.freeze([0xFB01, 0xFB02]),
    ]),
  }),
  serif: Object.freeze({
    label: "Serif",
    family: "Lora",
    weight: 500,
    asset: "lettering-7.ttf",
    sha256: "9bfe70fd1d70600c523d7ef66c8a024187270f115570d82baf97df7f05e6c2aa",
    codepointCount: 778,
    ranges: Object.freeze([
      Object.freeze([0xD, 0xD]),
      Object.freeze([0x20, 0x7E]),
      Object.freeze([0xA0, 0xAC]),
      Object.freeze([0xAE, 0x137]),
      Object.freeze([0x139, 0x17F]),
      Object.freeze([0x18F, 0x18F]),
      Object.freeze([0x192, 0x192]),
      Object.freeze([0x1A0, 0x1A1]),
      Object.freeze([0x1AF, 0x1B0]),
      Object.freeze([0x1B7, 0x1B7]),
      Object.freeze([0x1CD, 0x1CE]),
      Object.freeze([0x1D3, 0x1D4]),
      Object.freeze([0x1E4, 0x1E9]),
      Object.freeze([0x1EE, 0x1EF]),
      Object.freeze([0x1FE, 0x1FF]),
      Object.freeze([0x218, 0x21B]),
      Object.freeze([0x21E, 0x21F]),
      Object.freeze([0x237, 0x237]),
      Object.freeze([0x259, 0x259]),
      Object.freeze([0x292, 0x292]),
      Object.freeze([0x2BB, 0x2BC]),
      Object.freeze([0x2C6, 0x2C7]),
      Object.freeze([0x2C9, 0x2C9]),
      Object.freeze([0x2D8, 0x2DD]),
      Object.freeze([0x300, 0x304]),
      Object.freeze([0x306, 0x30C]),
      Object.freeze([0x312, 0x312]),
      Object.freeze([0x31B, 0x31B]),
      Object.freeze([0x323, 0x323]),
      Object.freeze([0x326, 0x328]),
      Object.freeze([0x335, 0x336]),
      Object.freeze([0x393, 0x394]),
      Object.freeze([0x3A0, 0x3A0]),
      Object.freeze([0x3A9, 0x3A9]),
      Object.freeze([0x3BC, 0x3BC]),
      Object.freeze([0x3C0, 0x3C0]),
      Object.freeze([0x400, 0x45F]),
      Object.freeze([0x462, 0x463]),
      Object.freeze([0x46A, 0x46D]),
      Object.freeze([0x472, 0x475]),
      Object.freeze([0x48A, 0x4FF]),
      Object.freeze([0x510, 0x513]),
      Object.freeze([0x51A, 0x51D]),
      Object.freeze([0x524, 0x529]),
      Object.freeze([0x52E, 0x52F]),
      Object.freeze([0x1C81, 0x1C81]),
      Object.freeze([0x1C85, 0x1C85]),
      Object.freeze([0x1E80, 0x1E85]),
      Object.freeze([0x1E9E, 0x1E9E]),
      Object.freeze([0x1EA0, 0x1EF9]),
      Object.freeze([0x2010, 0x2010]),
      Object.freeze([0x2013, 0x2014]),
      Object.freeze([0x2018, 0x201A]),
      Object.freeze([0x201C, 0x201E]),
      Object.freeze([0x2020, 0x2022]),
      Object.freeze([0x2026, 0x2026]),
      Object.freeze([0x2030, 0x2030]),
      Object.freeze([0x2032, 0x2033]),
      Object.freeze([0x2039, 0x203A]),
      Object.freeze([0x2044, 0x2044]),
      Object.freeze([0x2052, 0x2052]),
      Object.freeze([0x2074, 0x2074]),
      Object.freeze([0x20AC, 0x20AC]),
      Object.freeze([0x20AE, 0x20AE]),
      Object.freeze([0x20B4, 0x20B4]),
      Object.freeze([0x20B8, 0x20B8]),
      Object.freeze([0x20BA, 0x20BA]),
      Object.freeze([0x20BD, 0x20BD]),
      Object.freeze([0x2113, 0x2113]),
      Object.freeze([0x2116, 0x2116]),
      Object.freeze([0x2122, 0x2122]),
      Object.freeze([0x2126, 0x2126]),
      Object.freeze([0x212A, 0x212B]),
      Object.freeze([0x212E, 0x212E]),
      Object.freeze([0x2202, 0x2202]),
      Object.freeze([0x2206, 0x2206]),
      Object.freeze([0x220F, 0x220F]),
      Object.freeze([0x2211, 0x2212]),
      Object.freeze([0x2215, 0x2215]),
      Object.freeze([0x2219, 0x221A]),
      Object.freeze([0x221E, 0x221E]),
      Object.freeze([0x222B, 0x222B]),
      Object.freeze([0x2248, 0x2248]),
      Object.freeze([0x2260, 0x2260]),
      Object.freeze([0x2264, 0x2265]),
      Object.freeze([0x25CA, 0x25CA]),
      Object.freeze([0x27E8, 0x27E9]),
      Object.freeze([0xEFFD, 0xEFFD]),
      Object.freeze([0xFB01, 0xFB02]),
    ]),
  }),
  script: Object.freeze({
    label: "Script",
    family: "Pinyon Script",
    weight: 400,
    asset: "lettering-8.ttf",
    sha256: "3683830e3bb3f1a2138b6098f8663ca5ceb66b1f397a4f30639aae139e344bb8",
    codepointCount: 757,
    ranges: Object.freeze([
      Object.freeze([0xD, 0xD]),
      Object.freeze([0x20, 0x7E]),
      Object.freeze([0xA0, 0xAC]),
      Object.freeze([0xAE, 0x148]),
      Object.freeze([0x14A, 0x17F]),
      Object.freeze([0x181, 0x181]),
      Object.freeze([0x189, 0x18A]),
      Object.freeze([0x18E, 0x18F]),
      Object.freeze([0x192, 0x192]),
      Object.freeze([0x198, 0x199]),
      Object.freeze([0x1A0, 0x1A1]),
      Object.freeze([0x1AF, 0x1B0]),
      Object.freeze([0x1B3, 0x1B6]),
      Object.freeze([0x1C4, 0x1E3]),
      Object.freeze([0x1E6, 0x1EB]),
      Object.freeze([0x1F1, 0x1F5]),
      Object.freeze([0x1F8, 0x21B]),
      Object.freeze([0x21E, 0x21F]),
      Object.freeze([0x226, 0x233]),
      Object.freeze([0x237, 0x237]),
      Object.freeze([0x245, 0x245]),
      Object.freeze([0x253, 0x253]),
      Object.freeze([0x256, 0x257]),
      Object.freeze([0x259, 0x259]),
      Object.freeze([0x28C, 0x28C]),
      Object.freeze([0x2C6, 0x2C7]),
      Object.freeze([0x2D8, 0x2DD]),
      Object.freeze([0x300, 0x304]),
      Object.freeze([0x306, 0x30C]),
      Object.freeze([0x30F, 0x30F]),
      Object.freeze([0x311, 0x312]),
      Object.freeze([0x31B, 0x31B]),
      Object.freeze([0x323, 0x328]),
      Object.freeze([0x32D, 0x32E]),
      Object.freeze([0x330, 0x331]),
      Object.freeze([0x1E00, 0x1E37]),
      Object.freeze([0x1E3A, 0x1E95]),
      Object.freeze([0x1E97, 0x1E97]),
      Object.freeze([0x1E9E, 0x1E9E]),
      Object.freeze([0x1EA0, 0x1EF9]),
      Object.freeze([0x2000, 0x200B]),
      Object.freeze([0x200D, 0x200D]),
      Object.freeze([0x2011, 0x2011]),
      Object.freeze([0x2013, 0x2014]),
      Object.freeze([0x2018, 0x201A]),
      Object.freeze([0x201C, 0x201E]),
      Object.freeze([0x2020, 0x2022]),
      Object.freeze([0x2026, 0x2026]),
      Object.freeze([0x202F, 0x202F]),
      Object.freeze([0x2032, 0x2033]),
      Object.freeze([0x2039, 0x203A]),
      Object.freeze([0x2044, 0x2044]),
      Object.freeze([0x205F, 0x205F]),
      Object.freeze([0x2074, 0x2074]),
      Object.freeze([0x20AC, 0x20AC]),
      Object.freeze([0x2116, 0x2116]),
      Object.freeze([0x2122, 0x2122]),
      Object.freeze([0x212E, 0x212E]),
      Object.freeze([0x2153, 0x2154]),
      Object.freeze([0x2212, 0x2212]),
      Object.freeze([0x2260, 0x2260]),
      Object.freeze([0x25CC, 0x25CC]),
      Object.freeze([0xA78B, 0xA78C]),
      Object.freeze([0xFB01, 0xFB02]),
    ]),
  }),
});


/** Local preview state only. No cart, storage or production approval is implied. */
const PLACEMENTS = Object.freeze({
  weekender: 'body-between-straps',
  messenger: 'flap-centre',
});
const COLOURS = new Set(['brown', 'black']);
const FORMATS = new Set(['text', 'monogram']);
const FONTS = new Set(['roman', 'serif', 'script']);
const STRING_FIELDS = new Set(['colour', 'format', 'line1', 'line2', 'font', 'initial1', 'initial2']);
const EDITABLE_FIELDS = [...STRING_FIELDS, 'secondLine'];
const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
const graphemes = value => [...segmenter.segment(value)].map(part => part.segment);
const clone = value => structuredClone(value);
const INVISIBLE_OR_ENCLOSING = /[\p{Default_Ignorable_Code_Point}\p{Me}]/u;

function initialDraft(productId, colour = 'brown') {
  return { productId, colour, format: 'text', line1: '', line2: '', secondLine: false,
    font: 'roman', initial1: '', initial2: '' };
}

function validLimit(maxChars) {
  return Number.isInteger(maxChars) && maxChars > 0;
}

function unsupportedGlyphs(value, font) {
  const ranges = FONT_COVERAGE[font].ranges;
  return [...new Set([...value.normalize('NFC')].filter(character => {
    const cp = character.codePointAt(0);
    return !ranges.some(([first, last]) => cp >= first && cp <= last);
  }))];
}

function excessiveAccents(value) {
  return graphemes(value.normalize('NFC')).some(part => (part.match(/\p{M}/gu) || []).length > 2);
}

function fontError(value, font, label, monogram = false) {
  const missing = unsupportedGlyphs(value, font);
  if (!missing.length) return null;
  const glyphs = missing.slice(0, 3).map(character => `“${character}”`).join(', ');
  const action = monogram
    ? 'Edit this initial using a supported Latin letter.'
    : `Choose another lettering style or edit ${label.toLowerCase()}.`;
  return `${FONT_COVERAGE[font].label} lettering cannot display ${glyphs} in ${label.toLowerCase()}. ${action}`;
}

function textError(value, maxChars, label, font = 'roman') {
  if (typeof value !== 'string' || !value.trim()) return `Enter ${label.toLowerCase()}.`;
  // Only ordinary spaces are accepted: line breaks, invisible controls and markup
  // cannot silently change the mark that the customer has checked.
  if (!/^[\p{Script=Latin}\p{M}0-9 .,'’‘\-‐‑–&()]+$/u.test(value)
    || INVISIBLE_OR_ENCLOSING.test(value)
    || graphemes(value).some(part => /\p{M}/u.test(part) && !/^\p{Script=Latin}\p{M}*$/u.test(part))) {
    return `${label} in ${FONT_COVERAGE[font].label} lettering can contain supported Latin letters, digits 0–9, spaces and common name punctuation. Edit unsupported characters or emoji.`;
  }
  if (graphemes(value).length > maxChars) return `${label} must be ${maxChars} characters or fewer.`;
  if (excessiveAccents(value)) return `Edit ${label.toLowerCase()}: ${FONT_COVERAGE[font].label} lettering supports no more than two extra accent marks on a letter.`;
  return fontError(value, font, label);
}

function isInitial(value) {
  return typeof value === 'string' && !INVISIBLE_OR_ENCLOSING.test(value)
    && graphemes(value).length === 1 && /^\p{Script=Latin}\p{M}*$/u.test(value);
}

function initialError(value, label) {
  if (!isInitial(value)) return `Enter one supported Latin letter in the ${label} field for Classic lettering.`;
  if (excessiveAccents(value)) return `Edit the ${label}: Classic lettering supports no more than two extra accent marks on a letter.`;
  return fontError(value, 'roman', label, true);
}

/** Return exactly what the customer entered, without examples or HTML. */
function previewText(state) {
  if (state.format === 'monogram') {
    if (!state.initial1 && !state.initial2) return '';
    return `${state.initial1 || ''} | ${state.initial2 || ''}`;
  }
  return state.secondLine ? `${state.line1 || ''}\n${state.line2 || ''}` : state.line1 || '';
}

/** Validate a specification without requiring the spelling confirmation. */
function buildSelection(state, maxChars = 20) {
  if (!state || !Object.hasOwn(PLACEMENTS, state.productId)) return { ok: false, error: 'Choose a supported bag.' };
  if (!validLimit(maxChars)) return { ok: false, error: 'The character limit must be a positive whole number.' };
  if (!COLOURS.has(state.colour)) return { ok: false, error: 'Choose brown or black leather.' };
  if (!FORMATS.has(state.format)) return { ok: false, error: 'Choose text or a split monogram.' };
  if (!FONTS.has(state.font)) return { ok: false, error: 'Choose a supported font.' };
  if (typeof state.secondLine !== 'boolean') return { ok: false, error: 'Choose whether to add a second line.' };

  let lines;
  if (state.format === 'monogram') {
    const fieldErrors = {};
    const firstError = initialError(state.initial1, 'first initial');
    const secondError = initialError(state.initial2, 'second initial');
    if (firstError) fieldErrors.initial1 = firstError;
    if (secondError) fieldErrors.initial2 = secondError;
    if (Object.keys(fieldErrors).length) {
      return { ok: false, error: Object.values(fieldErrors)[0], fieldErrors };
    }
    lines = [`${state.initial1} | ${state.initial2}`];
  } else {
    const fieldErrors = {};
    const firstError = textError(state.line1, maxChars, 'Your text', state.font);
    if (firstError) fieldErrors.line1 = firstError;
    if (state.secondLine) {
      const secondError = textError(state.line2, maxChars, 'Second line', state.font);
      if (secondError) fieldErrors.line2 = secondError;
    }
    if (Object.keys(fieldErrors).length) return { ok: false, error: Object.values(fieldErrors)[0], fieldErrors };
    lines = state.secondLine ? [state.line1, state.line2] : [state.line1];
  }

  return { ok: true, selection: {
    productId: state.productId,
    colour: state.colour,
    format: state.format,
    text: lines.join('\n'),
    lines,
    font: state.format === 'monogram' ? 'roman' : state.font,
    placementId: PLACEMENTS[state.productId],
    maxChars,
    version: 1,
    price: null,
    productionApproved: false,
  } };
}

function seedInitials(draft, maxChars) {
  if (textError(draft.line1, maxChars, 'Your text', draft.font)) return null;
  // A date, dedication or message on line two never supplies a person's initials.
  const words = draft.line1.match(/\p{L}[\p{L}\p{M}]*/gu) || [];
  if (!words.length) return null;
  const first = graphemes(words[0]);
  const last = words.length > 1 ? graphemes(words.at(-1))[0] : first.length === 2 ? first[1] : '';
  return { initial1: first[0], initial2: last };
}

function activeSpec(draft) {
  return {
    productId: draft.productId, colour: draft.colour, format: draft.format,
    font: draft.format === 'monogram' ? 'roman' : draft.font,
    text: previewText(draft),
    secondLine: draft.format === 'text' && draft.secondLine,
  };
}

/**
 * const model = createModel('weekender');
 * model.update({ line1: 'Alex Morgan' });
 * model.confirm(true);
 * const { ok, selection } = model.save();
 */
function createModel(productId, maxChars = 20) {
  if (!Object.hasOwn(PLACEMENTS, productId)) throw new TypeError('Unsupported engraving product.');
  if (!validLimit(maxChars)) throw new TypeError('maxChars must be a positive whole number.');
  let draft = initialDraft(productId);
  let confirmed = false;
  let saved = null;
  let savedDraft = null;
  let monogramEdited = false;
  let savedMonogramEdited = false;
  let undoSnapshot = null;

  function capture() {
    return clone({ draft, confirmed, saved, savedDraft, monogramEdited, savedMonogramEdited });
  }

  function rememberChange(before) {
    if (JSON.stringify(before) !== JSON.stringify(capture())) undoSnapshot = before;
  }

  function freezeSelection(selection) {
    return selection ? Object.freeze({ ...selection, lines: Object.freeze([...selection.lines]) }) : null;
  }

  function getState() {
    const comparison = savedDraft || initialDraft(productId, draft.colour);
    return clone({ ...draft, confirmed, saved, canUndo: Boolean(undoSnapshot),
      dirty: JSON.stringify(activeSpec(draft)) !== JSON.stringify(activeSpec(comparison)) });
  }

  function update(patch = {}) {
    if (!patch || typeof patch !== 'object' || Array.isArray(patch)) throw new TypeError('Provide a field update object.');
    const next = { ...draft };
    for (const key of EDITABLE_FIELDS) {
      if (!Object.hasOwn(patch, key)) continue;
      if (STRING_FIELDS.has(key) && typeof patch[key] !== 'string') throw new TypeError(`${key} must be text.`);
      if (key === 'secondLine' && typeof patch[key] !== 'boolean') throw new TypeError('secondLine must be true or false.');
      next[key] = patch[key];
    }
    if (!COLOURS.has(next.colour) || !FORMATS.has(next.format) || !FONTS.has(next.font)) {
      throw new TypeError('Unsupported colour, format or font.');
    }
    const nextMonogramEdited = monogramEdited
      || Object.hasOwn(patch, 'initial1') || Object.hasOwn(patch, 'initial2');
    if (next.format === 'monogram' && !nextMonogramEdited
      && (draft.format !== 'monogram' || next.line1 !== draft.line1)) {
      Object.assign(next, seedInitials(next, maxChars) || { initial1: '', initial2: '' });
    }
    if (EDITABLE_FIELDS.some(key => next[key] !== draft[key])) {
      confirmed = false;
      // Comparing leather colours should not erase recovery for a removed mark.
      if (EDITABLE_FIELDS.some(key => key !== 'colour' && next[key] !== draft[key])) undoSnapshot = null;
    }
    draft = next;
    monogramEdited = nextMonogramEdited;
    return getState();
  }

  function confirm(value) {
    confirmed = value === true && buildSelection(draft, maxChars).ok;
    return getState();
  }

  function save() {
    const result = buildSelection(draft, maxChars);
    if (!result.ok) return result;
    if (!confirmed) return { ok: false, error: 'Confirm the spelling and design before saving.' };
    saved = freezeSelection(result.selection);
    savedDraft = clone(draft);
    savedMonogramEdited = monogramEdited;
    undoSnapshot = null;
    return { ok: true, selection: clone(saved) };
  }

  function cancel() {
    const before = capture();
    const colour = draft.colour;
    draft = savedDraft ? { ...clone(savedDraft), colour } : initialDraft(productId, colour);
    monogramEdited = savedDraft ? savedMonogramEdited : false;
    confirmed = Boolean(savedDraft && savedDraft.colour === colour);
    rememberChange(before);
    return getState();
  }

  function remove() {
    const before = capture();
    draft = initialDraft(productId, draft.colour);
    confirmed = false;
    saved = null;
    savedDraft = null;
    monogramEdited = false;
    savedMonogramEdited = false;
    rememberChange(before);
    return getState();
  }

  /** Restore the most recent discarded draft or removal. This is one step, not redo. */
  function undo() {
    if (!undoSnapshot) return getState();
    const colour = draft.colour;
    const previous = clone(undoSnapshot);
    draft = { ...previous.draft, colour };
    confirmed = previous.confirmed && previous.draft.colour === colour;
    saved = freezeSelection(previous.saved);
    savedDraft = previous.savedDraft;
    monogramEdited = previous.monogramEdited;
    savedMonogramEdited = previous.savedMonogramEdited;
    undoSnapshot = null;
    return getState();
  }

  return Object.freeze({ getState, update, confirm, save, cancel, remove, undo });
}


/** Builds purchase data; it never changes a cart or trusts preview prices as a quote. */
const SCHEMA = 'bellvari.engraving.purchase.v1';
const LIMITS = Object.freeze({ weekender: 20, messenger: 20 });
const LEGACY_LIMITS = Object.freeze({ weekender: 20, messenger: 24 });
const LABELS = Object.freeze({ weekender: 'Weekender', messenger: 'Messenger' });
const FONT_NAMES = Object.freeze({ roman: 'Cinzel (Classic)', serif: 'Lora (Serif)', script: 'Pinyon Script (Script)' });
const TERMS_VERSION = '20260912-personalized-bag-v1';
const RETURNS_NOTICE = 'Personalized bags are made to order and cannot be returned or exchanged for a change of mind. If your bag arrives damaged or the engraving differs from your confirmed design, contact support@bellvari.ca so we can help.';
const PREVIEW_NOTICE = 'Engraving is permanent. This is a simulated preview; leather grain, engraving colour and placement may vary slightly.';
const PREFIX = '_bellvari_';
const fail = error => ({ ok: false, error, items: [], spec: null });
const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const positive = value => typeof value === 'number' && Number.isFinite(value) && value > 0;
const count = value => Number.isSafeInteger(value) && value > 0;
const plainText = (value, max = 100) => typeof value === 'string' && value.trim().length > 0
  && value.length <= max && !/[\u0000-\u001f\u007f]/u.test(value);
const currencyCode = value => typeof value === 'string' && /^[A-Z]{3}$/u.test(value);
const same = (a, b) => {
  try { return JSON.stringify(a) === JSON.stringify(b); } catch { return false; }
};

function variantId(value) {
  if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
  return typeof value === 'string' && /^[1-9]\d{0,19}$/u.test(value) ? value : null;
}

function cleanProof(proof) {
  if (proof == null) return { ok: true, value: null };
  if (!object(proof)) return { ok: false, error: 'The engraving proof could not be attached. Save the design again.' };
  const value = {};
  for (const [key, max] of [['reference', 2048], ['revision', 80], ['referenceId', 120], ['label', 80]]) {
    if (!Object.hasOwn(proof, key)) continue;
    if (!plainText(proof[key], max)) return { ok: false, error: 'The engraving proof reference is invalid.' };
    value[key] = proof[key];
  }
  let publicReference = null;
  if (value.reference && /^[a-z][a-z0-9+.-]*:/iu.test(value.reference)) {
    let url;
    try { url = new URL(value.reference); } catch { return { ok: false, error: 'The engraving proof link is invalid.' }; }
    const loopback = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
    if (url.username || url.password || !(url.protocol === 'https:' || (url.protocol === 'http:' && loopback))) {
      return { ok: false, error: 'The engraving proof needs a secure preview link.' };
    }
    publicReference = value.reference;
  }
  if (Object.hasOwn(proof, 'svg')) {
    const svg = proof.svg;
    // A compact, inert proof only. Never put image bytes or executable markup in order properties.
    if (typeof svg !== 'string' || svg.length > 4096 || !/^\s*<svg[\s>]/u.test(svg)
      || !/<\/svg>\s*$/u.test(svg)
      || /<\s*(?:script|foreignObject|iframe|image|use|object|embed|a|animate\w*|set)\b|\bon\w+\s*=|\b(?:href|src)\s*=|url\s*\(|<!|<\?/iu.test(svg)) {
      return { ok: false, error: 'The engraving proof must be a small, static SVG without external content.' };
    }
    value.svg = svg;
  }
  return { ok: true, value: Object.keys(value).length ? value : null, publicReference };
}

// Reference approval records the merchant's pictured placement, never an inferred
// millimetre measurement. The proof must describe this exact bag and inscription.
function checkedPlacementReference(production, design, proof) {
  const reference = production.references?.[design.colour];
  // Historical Weekender proofs retain their original viewer and placement.
  // A new reference must use the viewer that renders that exact geometry.
  const proofView = reference?.revision === '20260911r2'
    ? 'engraving-studio'
    : design.productId === 'weekender' && ['20260912r3', '20260912r4'].includes(reference?.revision)
      ? `engraving-studio-${reference.revision}` : null;
  if (!object(reference) || !proofView
    || reference.id !== `${design.productId}-${design.colour}-${reference.revision}`
    || proof.value?.referenceId !== reference.id || proof.value?.revision !== reference.revision
    || !proof.publicReference) return null;
  for (const key of ['fullImageUrl', 'detailImageUrl']) {
    try {
      const url = new URL(reference[key]);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.username || url.password) return null;
    } catch { return null; }
  }
  try {
    const url = new URL(proof.publicReference);
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
    // bellvari.com is the US market domain. The editor builds this link from the page origin.
    if (!local && !['bellvari.ca', 'www.bellvari.ca', 'bellvari.com', 'www.bellvari.com', 'pnfxee-af.myshopify.com'].includes(url.hostname)) return null;
    const handle = design.productId === 'weekender' ? 'the-weekender-full-grain-leather-travel-duffel-bag' : 'the-messenger';
    if (!url.pathname.endsWith(`/products/${handle}`) || url.searchParams.get('view') !== proofView) return null;
    const token = url.hash.slice(7);
    if (!url.hash.startsWith('#proof=') || token.length > 1800 || !/^[A-Za-z0-9_-]+$/.test(token)) return null;
    const data = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(token.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0))));
    if (data.version !== 1 || data.revision !== reference.revision || data.referenceId !== reference.id
      || data.placementBasis !== 'reference-image' || data.productId !== design.productId
      || data.colour !== design.colour || data.font !== design.font || data.format !== design.format
      || !same(data.lines, design.lines)) return null;
  } catch { return null; }
  return { id: reference.id, revision: reference.revision, fullImageUrl: reference.fullImageUrl, detailImageUrl: reference.detailImageUrl };
}

function checkedSelection(selection, production, limits) {
  if (!object(selection) || !Object.hasOwn(limits, selection.productId)) return { ok: false, error: 'Save an engraving for this bag before adding it.' };
  if (selection.version !== 1 || !count(selection.maxChars) || selection.maxChars > limits[selection.productId]) {
    return { ok: false, error: 'This engraving needs to be reviewed and saved again.' };
  }
  if (production.maxChars !== undefined && (!count(production.maxChars) || production.maxChars > limits[selection.productId])) {
    return { ok: false, error: 'The engraving character limit is not configured correctly.' };
  }
  if (!Array.isArray(selection.lines) || ![1, 2].includes(selection.lines.length)
    || selection.lines.some(line => typeof line !== 'string')) {
    return { ok: false, error: 'The saved engraving lines are incomplete. Save the design again.' };
  }
  let initials;
  if (selection.format === 'monogram') {
    initials = selection.lines[0].split(' | ');
    if (selection.lines.length !== 1 || initials.length !== 2 || selection.font !== 'roman') {
      return { ok: false, error: 'Review the two initials and save the design again.' };
    }
  }
  const limit = Math.min(selection.maxChars, production.maxChars ?? limits[selection.productId]);
  const rebuilt = buildSelection({
    productId: selection.productId, colour: selection.colour, format: selection.format,
    font: selection.font, line1: selection.lines[0], line2: selection.lines[1] ?? '',
    secondLine: selection.lines.length === 2,
    initial1: initials?.[0] ?? '', initial2: initials?.[1] ?? '',
  }, limit);
  if (!rebuilt.ok) return rebuilt;
  for (const key of ['productId', 'colour', 'format', 'font', 'text', 'lines', 'placementId', 'version']) {
    if (!same(selection[key], rebuilt.selection[key])) {
      return { ok: false, error: 'The saved engraving does not match its text or placement. Review and save it again.' };
    }
  }
  return { ok: true, selection: rebuilt.selection, initials };
}

/**
 * variant: { id, productId: 'weekender'|'messenger', colour, available, currency }
 * production: { approved, version, allowedFonts, placementLabel, widthMm, heightMm,
 *   currency, fee: {included:true} OR {variantId,available,currency,priceMinor}, maxChars? }
 * Production must come from trusted merchant configuration, never shopper-controlled fields.
 */
function buildPurchaseItems(input = {}) {
  return buildPurchaseItemsForTerms(input, TERMS_VERSION);
}

// Older saved carts keep the terms that were shown when their design was confirmed.
// New purchases always use the current terms through the public builder above.
function buildPurchaseItemsForTerms(input, termsVersion) {
  if (termsVersion !== undefined && termsVersion !== TERMS_VERSION) return fail('The engraving return terms changed. Review and save your design again.');
  if (!object(input)) return fail('The engraving purchase could not be prepared. Try again.');
  const { selection, confirmed, dirty, variant, quantity, production, personalizationId, confirmedAt, proof } = input;
  if (confirmed !== true || dirty !== false) return fail('Review and confirm the current engraving before adding it to your bag.');
  if (!object(production) || production.approved !== true || !plainText(production.version, 80)
    || !Array.isArray(production.allowedFonts) || !production.allowedFonts.length
    || production.allowedFonts.some(font => !Object.hasOwn(FONT_NAMES, font))
    || !plainText(production.placementLabel, 120)
    || ![undefined, 'measured-mm', 'reference-image'].includes(production.placementBasis)
    || (production.placementBasis !== 'reference-image' && (!positive(production.widthMm) || !positive(production.heightMm)))
    || !currencyCode(production.currency)) {
    return fail('Engraving is not ready to order for this bag yet.');
  }
  const checked = checkedSelection(selection, production, termsVersion ? LIMITS : LEGACY_LIMITS);
  if (!checked.ok) return fail(checked.error);
  const design = checked.selection;
  if (!production.allowedFonts.includes(design.font)) return fail('This lettering is not available for engraving. Choose an approved lettering style.');
  if ((production.productId !== undefined && production.productId !== design.productId)
    || (production.placementId !== undefined && production.placementId !== design.placementId)) {
    return fail('The engraving setup does not match this bag and placement.');
  }
  const bagId = object(variant) && variantId(variant.id);
  if (!bagId || variant.available !== true) return fail('Choose an available bag before adding engraving.');
  if (variant.productId !== design.productId || variant.colour !== design.colour) return fail('The bag or colour changed. Review and confirm the engraving again.');
  if (!currencyCode(variant.currency) || variant.currency !== production.currency) return fail('The engraving price must match the currency of your bag.');
  if (!count(quantity)) return fail('Choose a whole number of bags greater than zero.');
  if (typeof personalizationId !== 'string' || !/^[A-Za-z0-9][A-Za-z0-9_-]{0,79}$/u.test(personalizationId)) return fail('The engraving reference is missing. Save the design again.');
  if (typeof confirmedAt !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/u.test(confirmedAt)
    || !Number.isFinite(Date.parse(confirmedAt))) return fail('Confirm the engraving again before adding it to your bag.');
  const rawFee = production.fee;
  if (!object(rawFee)) return fail('The engraving fee has not been configured.');
  let fee;
  if (rawFee.included === true) {
    if (rawFee.variantId != null || (rawFee.priceMinor != null && rawFee.priceMinor !== 0)
      || (rawFee.currency != null && rawFee.currency !== production.currency)) return fail('The included engraving fee is not configured correctly.');
    fee = { included: true, currency: production.currency, priceMinor: 0 };
  } else {
    const feeId = variantId(rawFee.variantId);
    if (!feeId || feeId === bagId || rawFee.available !== true) return fail('The engraving fee is unavailable. Your bag has not been added.');
    if (rawFee.currency !== production.currency || !count(rawFee.priceMinor)) return fail('The engraving price has not been confirmed in this currency.');
    fee = { included: false, variantId: feeId, available: true, currency: rawFee.currency, priceMinor: rawFee.priceMinor };
  }
  const proofResult = cleanProof(proof);
  if (!proofResult.ok) return fail(proofResult.error);
  const referenceBased = production.placementBasis === 'reference-image';
  const placementReference = referenceBased ? checkedPlacementReference(production, design, proofResult) : null;
  if (referenceBased && !placementReference) return fail('The saved design does not match the approved bag placement. Review and save your engraving again.');
  const spec = {
    schema: SCHEMA, personalizationId, selection: design,
    ...(checked.initials ? { initials: [...checked.initials] } : {}),
    production: {
      approved: true, version: production.version, productId: design.productId,
      allowedFonts: [...new Set(production.allowedFonts)], placementId: design.placementId,
      placementLabel: production.placementLabel,
      ...(referenceBased
        ? { placementBasis: 'reference-image', references: { [design.colour]: placementReference } }
        : { widthMm: production.widthMm, heightMm: production.heightMm }),
      maxChars: design.maxChars, currency: production.currency, fee,
    },
    variant: { id: bagId, productId: variant.productId, colour: variant.colour, available: true, currency: variant.currency },
    quantity, confirmedAt, ...(proofResult.value ? { proof: proofResult.value } : {}),
    ...(termsVersion ? { termsVersion } : {}),
  };
  const serialized = JSON.stringify(spec);
  if (serialized.length > 8192) return fail('The engraving proof is too large. Save a smaller proof or continue without it.');
  const link = {
    _bellvari_personalization_id: personalizationId, _bellvari_schema: SCHEMA,
    _bellvari_production_version: production.version, _bellvari_spec: serialized,
  };
  const bagProperties = {
    Engraving: design.text,
    'Engraving line 1': design.lines[0],
    ...(design.lines.length === 2 ? { 'Engraving line 2': design.lines[1] } : {}),
    ...(checked.initials ? { 'Engraving first initial': checked.initials[0], 'Engraving second initial': checked.initials[1] } : {}),
    'Engraving format': design.format === 'monogram' ? 'Two initials' : 'Text',
    'Engraving font': FONT_NAMES[design.font],
    'Engraving placement': production.placementLabel,
    ...(referenceBased
      ? { 'Engraving placement basis': 'Approved pictured placement', 'Engraving placement reference': placementReference.id }
      : { 'Engraving size': `${production.widthMm} × ${production.heightMm} mm` }),
    'Engraving colour': design.colour === 'brown' ? 'Brown' : 'Black',
    'Engraving confirmed': termsVersion
      ? `Spelling, lettering, placement and personalized returns terms confirmed on ${confirmedAt}`
      : `Spelling and design confirmed on ${confirmedAt}`,
    'Engraving returns': termsVersion ? RETURNS_NOTICE : 'Personalized bags are non-refundable.',
    ...(termsVersion ? { 'Engraving preview note': PREVIEW_NOTICE } : {}),
    ...(termsVersion && fee.included ? { 'Engraving price': 'Included' } : {}),
    ...(proofResult.publicReference ? { 'Engraving preview': proofResult.publicReference } : {}),
    ...link, _bellvari_role: 'bag',
  };
  const items = [{ id: bagId, quantity, properties: bagProperties }];
  if (!fee.included) items.push({ id: fee.variantId, quantity, properties: {
    'Engraving for': design.text, 'Engraving product': LABELS[design.productId],
    'Engraving placement': production.placementLabel,
    ...link, _bellvari_role: 'fee',
  } });
  return { ok: true, error: null, items, spec };
}

/**
 * Checks paired generated items or Shopify cart lines. This is a consistency gate,
 * not authentication of browser-supplied configuration or a substitute for platform prices.
 * Optional trusted {production, variants} rechecks configuration/catalogue at checkout.
 * Discount allocations may split one design over distinct Shopify line keys.
 * Cart quantity changes are valid when aggregate bag and fee quantities remain equal; spec.quantity
 * records the original request and is not treated as an immutable cart quantity.
 */
function validatePurchaseCart(lines, context = {}) {
  const invalid = error => ({ ok: false, error });
  if (!Array.isArray(lines)) return invalid('The bag could not be checked. Refresh and try again.');
  if (!object(context)) return invalid('The engraving setup could not be checked.');
  const groups = new Map();
  for (const line of lines) {
    if (!object(line)) return invalid('A bag item could not be checked.');
    const props = line.properties ?? {};
    if (!object(props)) return invalid('An engraving item has invalid details.');
    if (!Object.keys(props).some(key => key.startsWith(PREFIX) || key.startsWith('Engraving'))) continue;
    const id = props._bellvari_personalization_id;
    if (typeof id !== 'string' || !id || !['bag', 'fee'].includes(props._bellvari_role)) return invalid('An engraving item is missing its linked bag.');
    if (!count(line.quantity)) return invalid('An engraving quantity is invalid.');
    if (!groups.has(id)) groups.set(id, []);
    groups.get(id).push(line);
  }
  for (const [id, group] of groups) {
    const presentKeys = group.map(line => line.key).filter(key => key !== undefined && key !== null);
    if (new Set(presentKeys).size !== presentKeys.length) return invalid('The engraving cart contains duplicate line keys.');
    const bags = group.filter(line => line.properties._bellvari_role === 'bag');
    const fees = group.filter(line => line.properties._bellvari_role === 'fee');
    if (!bags.length) return invalid('Each engraving must be linked to a bag item.');
    const bag = bags[0];
    let spec;
    try { spec = JSON.parse(bag.properties._bellvari_spec); } catch { return invalid('The saved engraving details could not be read.'); }
    if (!object(spec) || spec.schema !== SCHEMA || spec.personalizationId !== id) return invalid('The engraving reference does not match its saved details.');
    const trustedProduction = context.production?.[spec.selection?.productId] ?? context.production ?? spec.production;
    let trustedVariant = spec.variant;
    if (context.variants !== undefined) {
      trustedVariant = Array.isArray(context.variants)
        ? context.variants.find(variant => variantId(variant?.id) === variantId(spec.variant?.id))
        : context.variants?.[spec.variant?.id];
      if (!trustedVariant) return invalid('This bag variant is no longer available for engraving.');
    }
    const rebuilt = buildPurchaseItemsForTerms({
      selection: spec.selection, confirmed: true, dirty: false, variant: trustedVariant,
      quantity: spec.quantity, production: trustedProduction, personalizationId: id,
      confirmedAt: spec.confirmedAt, proof: spec.proof,
    }, spec.termsVersion);
    if (!rebuilt.ok) return invalid(rebuilt.error);
    if (!same(spec, rebuilt.spec)) return invalid('The engraving configuration changed. Review the design and fee again.');
    const paid = rebuilt.items.length === 2;
    if ((paid && !fees.length) || (!paid && fees.length)) return invalid('The engraving fee is missing or duplicated.');
    const bagQuantity = bags.reduce((total, line) => total + line.quantity, 0);
    const feeQuantity = fees.reduce((total, line) => total + line.quantity, 0);
    if (!count(bagQuantity) || (paid && !count(feeQuantity))) return invalid('An engraving quantity is invalid.');
    if (paid && feeQuantity !== bagQuantity) return invalid('The engraving quantity must match its bag quantity.');
    for (const [index, roleLines] of [bags, fees].entries()) {
      if (!roleLines.length) continue;
      const expected = rebuilt.items[index];
      const referenceLine = roleLines[0];
      const propertyKeys = Object.keys(referenceLine.properties).sort();
      const lineKeys = new Set();
      for (const line of roleLines) {
        if (variantId(line.variant_id ?? line.id) !== expected.id) return invalid('The engraving is linked to the wrong bag or fee item.');
        for (const [key, value] of Object.entries(expected.properties)) {
          if (line.properties[key] !== value) return invalid('The engraving details changed. Review the saved design again.');
        }
        const unexpected = Object.keys(line.properties).some(key => (key.startsWith(PREFIX) || key.startsWith('Engraving'))
          && !Object.hasOwn(expected.properties, key));
        if (unexpected) return invalid('The engraving item has conflicting details.');
        if (roleLines.length > 1) {
          // A real allocation split has distinct line keys and the same entire
          // design, custom properties and selling plan. Duplicate add payloads,
          // changed notes and conflicting specifications are not allocation splits.
          if (!plainText(line.key, 256) || lineKeys.has(line.key)) return invalid('The engraving split could not be matched to distinct cart lines.');
          lineKeys.add(line.key);
          if (!same(Object.keys(line.properties).sort(), propertyKeys)
            || propertyKeys.some(key => !same(line.properties[key], referenceLine.properties[key]))
            || !same(line.selling_plan_allocation?.selling_plan ?? line.selling_plan ?? null,
              referenceLine.selling_plan_allocation?.selling_plan ?? referenceLine.selling_plan ?? null)) {
            return invalid('Split engraving items have conflicting details. Review or remove this personalized selection.');
          }
        }
      }
    }
  }
  return { ok: true, error: null };
}

window.BellvariEngravingContract=Object.freeze({buildPurchaseItems,validatePurchaseCart});
})();
